import type { SchoolTestType } from './schemas'

export const SCHOOL_TEST_TYPE_KO = {
  MIDTERM: '중간',
  FINAL: '기말',
} as const satisfies Record<SchoolTestType, string>
